import React from 'react';

import { View } from '@rbilabs/universal-components';
import { StoreOrderingUnavailableDialog } from 'features/store/components';

import { USE_GLOBAL_APP_MODALS_IN_CARD_MODAL } from 'components/card-modal';
import { ModalAuth } from 'components/modal-auth';
import { RemoveUnavailableItemsModal } from 'components/remove-unavailable-items-modal';
import { CurbsideConfirmationModal } from 'components/top-service-mode/curbside-confirmation-modal';
import { useAuthContext } from 'state/auth';
import { ModalAuthTrigger } from 'state/auth/types';
import { MaybeShowOnboardingContent } from 'state/onboarding';
import { useOrderContext } from 'state/order';
import { useUIContext } from 'state/ui';

/** put modals that should be globally available in the app here.
 * NOTE this is also mounted in <CardModal/> on ios so they can show up in an iOS modal
 */
export const GlobalAppModals = ({ isModal = false }) => {
  const { modalAuthState } = useAuthContext();

  const {
    isPreConfirmCurbside,
    recent: { unavailablePendingRecentItem, setUnavailablePendingRecentItem },
  } = useOrderContext();

  const {
    isUpdateModalOpen,
    shouldShowPreConfirmCurbsideModal,
    setShouldShowPreConfirmCurbsideModal,
  } = useUIContext();

  const curbsideModalDismiss = () => {
    setShouldShowPreConfirmCurbsideModal(false);
  };

  return (
    <>
      <View testID="app-modals-layout">
        {unavailablePendingRecentItem && (
          <RemoveUnavailableItemsModal
            unavailableCartEntries={[unavailablePendingRecentItem]}
            onConfirmCb={() => setUnavailablePendingRecentItem(null)}
          />
        )}
      </View>
      <StoreOrderingUnavailableDialog />
      {getModalAuthComponent(modalAuthState.trigger, isModal)}
      {!isUpdateModalOpen && shouldShowPreConfirmCurbsideModal && isPreConfirmCurbside() && (
        <CurbsideConfirmationModal showDialog onDismiss={curbsideModalDismiss} />
      )}
    </>
  );
};

/** global app modals that only mount in the root of the app, not in <CardModal/> sub-modals on ios */
export const RootOnlyGlobalAppModals = () => {
  return <MaybeShowOnboardingContent />;
};

// only applicable to very nuanced iOS deep link, no auth situations
// needed where we can't have auth displaying on two screens (modal and non modal) at once
function getModalAuthComponent(trigger: ModalAuthTrigger | undefined, isModal: boolean) {
  if (!trigger) {
    return null;
  }

  if (
    !USE_GLOBAL_APP_MODALS_IN_CARD_MODAL &&
    (trigger === ModalAuthTrigger.Modal || trigger === ModalAuthTrigger.Global)
  ) {
    return <ModalAuth />;
  }

  if (trigger === ModalAuthTrigger.Global && !isModal) {
    return <ModalAuth />;
  }

  if (trigger === ModalAuthTrigger.Modal && isModal) {
    return <ModalAuth />;
  }
  return null;
}
